"use client";
import {
  TabScopedContextProvider,
  useTabProviderContext
} from "../__chunks/4B73HROV.js";
import {
  useComposite
} from "../__chunks/7QTPYGNZ.js";
import "../__chunks/3IEDWLST.js";
import "../__chunks/IB7YUKH5.js";
import "../__chunks/4UUKJZ4V.js";
import "../__chunks/KK7H3W2B.js";
import "../__chunks/SHA3WOPI.js";
import {
  createComponent,
  createElement,
  createHook
} from "../__chunks/3ORBWXWF.js";
import {
  useWrapElement
} from "../__chunks/6O5OEQGF.js";
import "../__chunks/XM66DUTO.js";
import {
  __objRest,
  __spreadValues
} from "../__chunks/4R3V3JGP.js";

// src/tab/tab-list.tsx
import { invariant } from "@ariakit/core/utils/misc";
import { jsx } from "react/jsx-runtime";
var useTabList = createHook((_a) => {
  var _b = _a, { store } = _b, props = __objRest(_b, ["store"]);
  const context = useTabProviderContext();
  store = store || context;
  invariant(
    store,
    process.env.NODE_ENV !== "production" && "TabList must receive a `store` prop or be wrapped in a TabProvider component."
  );
  const orientation = store.useState(
    (state) => state.orientation === "both" ? void 0 : state.orientation
  );
  props = useWrapElement(
    props,
    (element) => /* @__PURE__ */ jsx(TabScopedContextProvider, { value: store, children: element }),
    [store]
  );
  props = __spreadValues({
    role: "tablist",
    "aria-orientation": orientation
  }, props);
  props = useComposite(__spreadValues({ store }, props));
  return props;
});
var TabList = createComponent((props) => {
  const htmlProps = useTabList(props);
  return createElement("div", htmlProps);
});
if (process.env.NODE_ENV !== "production") {
  TabList.displayName = "TabList";
}
export {
  TabList,
  useTabList
};
